module.exports = "/_next/static/images/d95afcee7b23cbca9d4f3eaa86cf11f7-roxinho-card-with-phone-lg@2x.jpg.webp";